import React from 'react';

import ErrorBoundary from 'components/ErrorBoundary';

class RenderingErrorBoundary extends ErrorBoundary {
  public render() {
    return this.childrenWithProps({ isErrored: this.state.hasError });
  }

  private childrenWithProps(props: any) {
    return React.Children.map(this.props.children, (child, index) => {
      return React.isValidElement(child) ? React.cloneElement(child, props, index) : child;
    });
  }
}

export default RenderingErrorBoundary;
